import {useEffect, useState} from "react";
import {ButtonBase, Grid, IconButton, Typography} from '@mui/material'
import {Add, Remove} from '@mui/icons-material'

export const useHookBotonCantidadDrawer = ({variante}) => {
    const [max, setMax] = useState(0)
    const [cantidad, setCantidad] = useState(1)

    const agregar = () => {
        if (cantidad < max) {
            let nC = cantidad + 1
            setCantidad(nC)
        }
    }

    const restar = () => {
        if (cantidad > 1) {
            let nC = cantidad - 1
            setCantidad(nC)
        }
    }

    useEffect(() => {

        if (variante) {

            if (parseInt(variante.cantidad) > 0) {
                setMax(parseInt(variante.cantidad))
                setCantidad(1)
            } else {
                setMax(0)
                setCantidad(0)
            }


        }

    }, [variante]);
    const Boton = ({noBorrar = false}) => {

        return (

            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}>


                <Grid
                    container
                    justifyContent={'space-between'}
                    alignItems={'center'}
                    size={{xs: 12, sm: 12, md: 12}}
                    spacing={1}
                    sx={{border: 1, borderColor: '#00000050', py: 0}}

                >

                    <Grid container size={{xs: 4, sm: 4, md: 4}} sx={{justifyContent: 'center'}}>
                        <IconButton
                            onClick={() => restar()}
                            sx={{
                                borderRadius: 1,
                                p: 0.5
                            }}>

                            <Remove sx={{fill: '#00000080', width: 16, height: 16}}/>

                        </IconButton>
                    </Grid>

                    <Grid container size={{xs: 4, sm: 4, md: 4}} sx={{justifyContent: 'center'}}>
                        <Typography sx={{
                            color: '#4d4d4d',
                            borderRadius: 2,
                            fontWeight: 400,
                            fontSize: 14
                        }}>{cantidad}</Typography>
                    </Grid>

                    <Grid container size={{xs: 4, sm: 4, md: 4}} sx={{justifyContent: 'center'}}>
                        <ButtonBase
                            onClick={() => agregar()}
                            sx={{borderRadius: 1, p: 0.5}}>
                            <Add sx={{fill: '#00000080', width: 16, height: 16}}/>
                        </ButtonBase>
                    </Grid>


                </Grid>


            </Grid>
        )

    }

    return {
        Boton,
        cantidad
    }
}